var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 467;
var h = 467;
var nm = "Trendline  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 3,
        nm: "ArrowheadRig",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10,
                x: "var $bm_rt;\nvar pathToTrace = thisComp.layer('Line')('ADBE Root Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\nvar pathLayer = thisComp.layer('Line');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "Trace Path",
                np: 4,
                mn: "Pseudo/ADBE Trace Path",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 0,
                        nm: "Progress",
                        mn: "Pseudo/ADBE Trace Path-0001",
                        ix: 1,
                        v: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.833
                                        ],
                                        y: [
                                            0.833
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.167
                                        ],
                                        y: [
                                            0.167
                                        ]
                                    },
                                    t: 5,
                                    s: [
                                        0
                                    ]
                                },
                                {
                                    t: 15.9700006504714,
                                    s: [
                                        100
                                    ]
                                }
                            ],
                            ix: 1,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('Line').content('Trim Paths 1').start;"
                        }
                    },
                    {
                        ty: 7,
                        nm: "Loop",
                        mn: "Pseudo/ADBE Trace Path-0002",
                        ix: 2,
                        v: {
                            a: 0,
                            k: 1,
                            ix: 2
                        }
                    }
                ]
            }
        ],
        ip: 5.00000020365417,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "arrow",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    335.683,
                    177.51,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\n$bm_rt = thisComp.layer('ArrowheadRig').transform.position;"
            },
            a: {
                a: 0,
                k: [
                    45.192,
                    -45.192,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                45.192,
                                45.192
                            ],
                            [
                                45.192,
                                -45.192
                            ],
                            [
                                -45.192,
                                -45.192
                            ]
                        ],
                        c: false
                    },
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 9,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 16,
                            s: [
                                0
                            ],
                            h: 1
                        },
                        {
                            t: 102.000004154545,
                            s: [
                                0
                            ],
                            h: 1
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 9,
                            s: [
                                50
                            ]
                        },
                        {
                            t: 16,
                            s: [
                                100
                            ],
                            h: 1
                        },
                        {
                            t: 102.000004154545,
                            s: [
                                100
                            ],
                            h: 1
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.321568638086,
                        0.733333349228,
                        0.466666668653,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.11,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 5.00000020365417,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Line",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: 0.667,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 3,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            101.683,
                                            -56.49
                                        ],
                                        [
                                            11.298,
                                            33.894
                                        ],
                                        [
                                            -33.894,
                                            -11.298
                                        ],
                                        [
                                            -171.779,
                                            127.394
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.667,
                                y: 1
                            },
                            o: {
                                x: 0.333,
                                y: 0
                            },
                            t: 11,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            101.683,
                                            -56.49
                                        ],
                                        [
                                            11.298,
                                            33.894
                                        ],
                                        [
                                            -33.894,
                                            -11.298
                                        ],
                                        [
                                            -101.683,
                                            56.49
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        },
                        {
                            i: {
                                x: 0.833,
                                y: 0.833
                            },
                            o: {
                                x: 0.167,
                                y: 0.167
                            },
                            t: 16,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            101.683,
                                            -56.49
                                        ],
                                        [
                                            11.298,
                                            33.894
                                        ],
                                        [
                                            -33.894,
                                            -11.298
                                        ],
                                        [
                                            -101.683,
                                            56.49
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        },
                        {
                            t: 106.000004317469,
                            s: [
                                {
                                    i: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    o: [
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0
                                        ]
                                    ],
                                    v: [
                                        [
                                            111.683,
                                            -66.49
                                        ],
                                        [
                                            11.298,
                                            33.894
                                        ],
                                        [
                                            -33.894,
                                            -11.298
                                        ],
                                        [
                                            -101.683,
                                            56.49
                                        ]
                                    ],
                                    c: false
                                }
                            ]
                        }
                    ],
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.512
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 3,
                            s: [
                                100
                            ]
                        },
                        {
                            i: {
                                x: [
                                    0.833
                                ],
                                y: [
                                    0.833
                                ]
                            },
                            o: {
                                x: [
                                    0.167
                                ],
                                y: [
                                    0.167
                                ]
                            },
                            t: 16,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 106.000004317469,
                            s: [
                                0
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.321568638086,
                        0.733333349228,
                        0.466666668653,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.11,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Fill",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.65
                            ],
                            y: [
                                -0.72
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 15.0000006109625,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        -126.652
                                    ],
                                    [
                                        126.653,
                                        0
                                    ],
                                    [
                                        0,
                                        126.652
                                    ],
                                    [
                                        -126.653,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        126.652
                                    ],
                                    [
                                        -126.653,
                                        0
                                    ],
                                    [
                                        0,
                                        -126.652
                                    ],
                                    [
                                        126.653,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        229.325,
                                        0
                                    ],
                                    [
                                        0,
                                        229.325
                                    ],
                                    [
                                        -229.325,
                                        0
                                    ],
                                    [
                                        0,
                                        -229.325
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.941176474094,
                                0.972549021244,
                                0.964705884457,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var TrendLine = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, TrendLine as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Trending.json.es.js.map
